<template>
  <div>
    <TableErrorImportTeamLeadIndex v-if="tableError" :response-error="listErrors"/>
    <div v-else style="display: flex; flex-direction: column; gap: 20px">
      <div style="display: flex; flex-direction: column">
        <label>Bước 1: Tải xuống file mẫu</label>
        <button class="btn btn-primary" style="width: 130px" @click="downloadFileExcelExample">
          <i class="el-icon-bottom" style="color: white"></i>
          Tải xuống
        </button>
      </div>
      <div style="display: flex; flex-direction: column">
        <label>Bước 2: Tải file excel lên hệ thống</label>
        <div v-if="fileImport" style="display: flex; align-items: center; gap: 8px">
          <span>{{fileImport.name}}</span>
          <el-button type="text" @click="fileImport = null" class="btn-remove">
            <i class="el-icon-delete" style="color: red !important;"></i>
          </el-button>
        </div>
        <label v-else class="btn btn-warning" for="upload-file" style="width: 130px">
          <input type="file" style="display: none" id="upload-file" @change="handleFileUpload" accept=".xlsx, .xls" />
          <i class="el-icon-top" style="color: white"></i>
          Tải lên
        </label>
      </div>
    </div>
    <div style="display: flex;justify-content: flex-end; align-items: center; gap: 20px">
      <button
          class="btn btn-primary text-white"
          v-if="tableError"
          style="background: #5D04B0"
          @click="backToImport"
      >Quay lại</button>
      <button v-else class="btn" style="background: #CACACA" @click="closeDialog">Hủy bỏ</button>
      <el-button
          v-if="!tableError"
          :disabled="disableImport"
          v-loading="disableImport"
          class="btn btn-primary text-white"
          style="background: #5D04B0"
          @click="handleImportFileExcel"
      >
        Xác nhận
      </el-button>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import { IMPORT_INDEX_TEAM_LEAD } from "@/core/services/store/okrs/okr.module";
import TableErrorImportTeamLeadIndex
  from "@/view/pages/manage-team-lead-index/component/TableErrorImportTeamLeadIndex.vue";

export default {
  name: "DialogImportIndexTeamLead",
  components: { TableErrorImportTeamLeadIndex },
  data() {
    return {
      fileImport: null,
      dataImport: [],
      tableError: false,
      listErrors: [],
      disableImport: false,
    }
  },
  mounted() {},
  methods: {
    downloadFileExcelExample() {
      const filePath = process.env.BASE_URL + 'excel/File mẫu import chỉ số teamlead.xlsx';
      const a = document.createElement('a');
      a.href = filePath;
      a.download = 'File mẫu import chỉ số team lead.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileImport = file
        this.readExcelFile(file);
      }
    },
    readExcelFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const columnMapping = {
          "Mã nhân sự": 'user_id',
          "Quý": 'quarter',
          "Năm": 'year',
          "Mô tả": 'description',
          "Trạng thái": 'status',
        }
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const translatedHeaders = headers.map(header => columnMapping[header.trim()] || header.trim());
        this.dataImport = rows?.filter(item => item?.length > 0).map(row => {
          const obj = {};
          translatedHeaders.forEach((header, index) => {
            obj[header] = row[index] !== undefined && row[index] !== null
                ? row[index].toString().trim()
                : null;
          });
          return obj;
        })
      };
      reader.readAsArrayBuffer(file);
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    backToImport() {
      this.fileImport = null
      this.tableError = false
      this.disableImport = false
      this.listErrors = []
      this.$emit('setTitleError', 'Import chỉ số teamlead')
    },
    async handleImportFileExcel() {
      this.disableImport = true
      if (!this.fileImport) {
        this.$notify({
          title: 'Thất bại',
          message: 'Chưa có file nào được chọn',
          type: 'error'
        });
        return
      }
      if (this.dataImport?.length > 0) {
        await this.$store.dispatch(IMPORT_INDEX_TEAM_LEAD, this.dataImport).then(res => {
          if (!res.error && res?.data?.length > 0) {
            this.listErrors = res.data.map(item => {
              if (item?.error?.length > 0) {
                this.$emit('setTitleError', 'Báo lỗi')
                return {
                  userId: item?.user_id,
                  quarter: item?.quarter,
                  year: item?.year,
                  description: item?.description,
                  status: item?.status,
                  error: item?.error,
                }
              }
            })?.filter(item => item?.error?.length > 0)
            if (this.listErrors?.length > 0) {
              this.tableError = true
            }
            return;
          }
          if (!res.error) {
            this.$message.success('Import chỉ số team lead thành công!')
            this.$emit('getListManageIndexTeamLead')
            this.closeDialog()
          }
        }).catch(e => {
          console.log(e)
        }).finally(() => {
          this.disableImport = false
        })
      } else {
        this.$message.warning('Bạn không thể import khi file excel không có bản ghi nào')
        this.disableImport = false
      }
    },
  }
}
</script>